import queryString from 'query-string';

import { bebop as bebopApi } from 'core/api/definitions/bebop';
import { renderError as defaultRenderError } from 'core/utils/app-status-helper';
import { throwIfHistoryIsMissing } from 'core/utils/query';
import { denormalizeData } from 'core/utils/api';
import { getEnv, resolve } from 'core/utils/env';

import { PREVIEW_PREFIX } from 'core/site/constants';


export const topicQuery = queryParams => {
  throwIfHistoryIsMissing(queryParams, 'topicQuery in topic.js');

  const {
    include = 'all',
    renderError = defaultRenderError,
    location,
    match: { params: { topic_link: topicLink } },
    history,
  } = queryParams;

  const {
    preview_token: previewToken,
    is_mock: isMock,
  } = queryString.parse(location?.search || {});

  const commonQueryOptions = {
    // Не даём запросу уходить в isLoading при бесконечном скролле, т.к. это
    // приводит к перемонтированию InfiniteTopic и ломает подгрузку новых топиков
    keepPreviousData: !!location?.state?.infinity,
  };

  const isNotProd = resolve({
    '*': true,
    'production': false,
  });

  if (!!isMock && isNotProd) {
    const host = resolve({
      'dev': 'http://localhost:9000',
      '*': `https://${getEnv('SITE_HOST')}`,
    });

    return {
      ...commonQueryOptions,
      queryKey: [host, '/json/topic.json'],
      queryFn: ({ queryKey: [baseURL, mockPath] }) => bebopApi.getExternal(baseURL + mockPath),
      select: ({ data: json }) => {
        return json;
      },
    };
  }

  return {
    ...commonQueryOptions,
    queryKey: ['bebopApi', 'getTopic', {
      // На nginx есть правило, отрезающее `/preview`
      // Чтобы это не приводило к расхождению queryKey на ноде и на клиенте,
      // также игнорируем этот префикс
      topic_link: topicLink?.startsWith(PREVIEW_PREFIX)
        ? topicLink?.replace(PREVIEW_PREFIX, '')
        : topicLink,
      include,
      preview_token: previewToken,
    }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params).catch(err => renderError(err, history)),
    select: denormalizeData,
  };
};
